import { action, makeObservable, observable, flow } from "mobx";
import { API } from "aws-amplify";
import { getQuicksightEmbedUrl } from "../../../graphql/queries";

class PerformancePageStore {
  embedURL = "";
  status = "idle";
  isError = false;
  errorMessage = "";

  constructor() {
    makeObservable(this, {
      embedURL: observable,
      status: observable,
      isError: observable,
      errorMessage: observable,
      setEmbedURL: action.bound,
      fetchEmbedUrl: flow.bound,
      clear: action.bound
    });
  }

  setEmbedURL = (url) => {
    this.embedURL = url;
  };

  *fetchEmbedUrl() {
    try {
      this.status = "loading";
      const response = yield API.graphql({
        query: getQuicksightEmbedUrl,
        variables: {
          input: {
            event_type: "GET_EMBED_URL",
            dashboard_id: "a574165d-e197-431b-ad67-601fee6a9421",
            user_arn:
              "arn:aws:quicksight:us-east-1:943437388571:user/default/edgardo@dealerlakes.com",
            initial_topic_id: "TP3dllTh448wMOnYUKMfvtGRPPgyrqrK",
            session_lifetime_in_minutes: 60,
          },
        },
        authMode: "AMAZON_COGNITO_USER_POOLS",
      });

      if (!response.data?.getQuicksightEmbedUrl?.body) {
        throw new Error("Invalid response format");
      }

      const data = JSON.parse(response.data.getQuicksightEmbedUrl.body);
      this.embedURL = data["dashboard_url"];
      this.status = "idle";
    } catch (error) {
      console.error("Error fetching:", error);
      this.status = "error";
      this.isError = true;
      this.errorMessage = error.message || "Failed to fetch embed URL";
    }
  }

  clear = () => {
    this.embedURL = "";
    this.status = "idle";
    this.isError = false;
    this.errorMessage = "";
  };
}

const performancePageStore = new PerformancePageStore();
export default performancePageStore;